import ready from './ready'

export default async function syncDB(clear = false) {
  ready().then(registration => {
    if (registration) {
      navigator.serviceWorker.controller.postMessage({ type: 'SYNC_DB', payload: { clear: clear } })
    }
  })
}